import { Pie } from '@ant-design/charts'
import { Col, Row } from 'antd'
import { useDashboardMain } from 'Hooks/dashboardMain'
import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const SaleDashboardStyled = styled.div`
    text-align: start;
    height: 475px;
`

export default function SaleDashboard({ convertMoney }) {
  const [trans] = useTranslation(['dashboard'])
  const { dataDashboard } = useDashboardMain()
  const [valueProportionSales, setValueProportionSales] = useState(null)
  const dataPie = [
    {
      type: 'TEAM PLAN',
      value: valueProportionSales
    }
  ]
  const config = {
    appendPadding: 50,
    data: dataPie,
    angleField: 'value',
    colorField: 'type',
    radius: 1,
    innerRadius: 0.9,
    label: {
      content: ''
    },
    statistic: {
      title: false,
      content: {
        style: {
          whiteSpace: 'pre-wrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: '24px'

        },
        content: valueProportionSales ? `US$  ${convertMoney(valueProportionSales)}` : ''
      }
    },
    color: ['#58AFFF'],
    pieStyle: {
      width: 207,
      height: 207
    }
  }

  useEffect(() => {
    if (dataDashboard && dataDashboard.proportionSales) {
      setValueProportionSales(dataDashboard.proportionSales)
    }
  }, [dataDashboard])

  return (
    <SaleDashboardStyled>
      <Row>
        <Col span={24}>
          <span className="text-size-16">{trans('dashboard:sales')}</span>
        </Col>
      </Row>
      <Row gutter={[48, 24]} style={{ marginBottom: '24px' }}>
        <Col span={24} style={{ marginTop: '-46px', marginLeft: '-50px' }}>
          <Pie {...config} />
        </Col>
      </Row>
    </SaleDashboardStyled>
  )
}

SaleDashboard.propTypes = {
  convertMoney: PropTypes.func
}
